export interface BillingInfo {
  businessName: string;
  countryId: number;
  countryName: string;
  stateRegionId: number;
  stateRegionName: string;
  city: string;
  zipCode: string;
  businessAddress: string;
  businessAddressDetails: string;
  phoneNumber: string;
}

export class BillingInfoModel implements BillingInfo {
  businessName: string;
  countryId: number;
  countryName: string;
  stateRegionId: number;
  stateRegionName: string;
  city: string;
  zipCode: string;
  businessAddress: string;
  businessAddressDetails: string;
  phoneNumber: string;

  constructor(
    businessName: string = '',
    countryId: number = 0,
    countryName: string = '',
    stateRegionId: number = 0,
    stateRegionName: string = '',
    city: string = '',
    zipCode: string = '',
    businessAddress: string = '',
    businessAddressDetails: string = '',
    phoneNumber: string = ''
  ) {
    this.businessName = businessName;
    this.countryId = countryId;
    this.countryName = countryName;
    this.stateRegionId = stateRegionId;
    this.stateRegionName = stateRegionName;
    this.city = city;
    this.zipCode = zipCode;
    this.businessAddress = businessAddress;
    this.businessAddressDetails = businessAddressDetails;
    this.phoneNumber = phoneNumber;
  }
}
